import React from 'react';
import { Link } from 'react-router-dom';

export default function Sidebar() {
  return (
   <>
   
   <div className='col-md-2 sidebar'>

     <ul>
      <li><Link to="/">Home</Link></li>
     

      <li><Link to="/login">Login</Link></li>

      <li><Link to="/register">Register</Link></li>
      <li><Link to="/list">List</Link></li>
     </ul>

   </div>
   
   </>
  )
}
